<template>
  <div>
    <vue-headful title="Aanmelden" />
    <Header page_title="Aanmelden" />
    <div class="px-4 mx-2">
        <div class="container-fluid p-0">
            <p v-if="social">
                <strong>Registreer met social media:</strong>
            </p>
            <div class="row mb-3 pb-2" v-if="social">
                <div class="col pr-2">
                    <a
                        @click="AuthLinkedIn"
                        class="btn btn-outline-warning btn-block m-auto"
                        role="button"
                        v-ripple="'rgba(255, 193, 7, 0.35)'"
                    >
                        <span class="text-derect">LinkedIn</span>
                    </a>
                </div>
                <div class="col pl-2">
                    <a
                        @click="AuthGoogle"
                        class="btn btn-outline-warning btn-block m-auto"
                        role="button"
                        v-ripple="'rgba(255, 193, 7, 0.35)'"
                    >
                        <span class="text-derect">Google</span>
                    </a>
                </div>
            </div>
            <div class="row mb-5" hidden>
                <div class="col">
                    <input type="text" class="form-control" id="linkedin_code" v-model="linkedin_code" />
                    <input type="text" class="form-control" id="linkedin_state" v-model="linkedin_state" />
                </div>
            </div>
        <!-- <div v-if="this.type == 1">
          <p>Derect is als een goede dating-app. Ben je vrij en zoek je een invalklus in het onderwijs? Bijvoorbeeld voor een paar dagen of misschien wel voor drie weken? Door je voorkeuren en beschikbaarheid op te geven koppelen wij je binnen een paar klikken aan scholen die staan te springen om een invalleerkracht. Scholen zien direct wie op basis van zijn of haar voorkeuren bij een vacature past. Andersom krijg je als leerkracht de vacatures te zien die het beste op jouw wensen aansluiten. Is er wederzijdse interesse, dan koppelt Derect jullie aan elkaar en na uitwisseling van contactgegevens kunnen jullie verdere details bespreken voor de vervanging. De verloning en administratieve zaken verlopen gemakkelijk via Derect.</p>
          <p>Derect is recentelijk van start gegaan. Wil jij dus snel aan de slag als leerkracht? Schrijf je dan nu alvast in en loop geen opdracht mis!</p>
          <p>Op zoek naar een baan voor de langere termijn? Dat kan natuurlijk ook!</p>
        </div>
        <div v-if="this.type != 1">
          <p>Derect is dé eerste hulp bij onderwijsnood. Op korte termijn een invalleerkracht voor de klas nodig? Via Derect laat je weten wanneer je iemand nodig hebt. Kandidaten vullen in wanneer zij beschikbaar zijn. Op basis van ervaring, beschikbaarheid en afstand worden er matches gevormd. Is er wederzijdse interesse? Derect koppelt jullie aan elkaar en na uitwisseling van contactgegevens kunnen jullie verdere details bespreken voor de vervanging. De verloning en administratieve zaken verlopen gemakkelijk via Derect.</p>
        </div>-->
            <form class="pb-2 pt-4 sd-form" @submit.prevent="onSubmit" autocomplete="off">
                <NotificationContainer />

                <input type="hidden" class="form-control" v-model="form.branch" />

                <component
                    :is="educationComponent"
                    v-model="form"
                />

                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck1"
                        v-model="agree"
                        required
                    />

                    <label class="custom-control-label small" for="customCheck1">
                        Met het aanmaken van een account ga je akkoord met
                        <router-link
                            :to="{ name: this.type === 1 ? 'applicant-terms' : this.type === 2 ? 'company-terms' : 'terms' }"
                            title="onze voorwaarden"
                            class="text-derect"
                            target="_blank"
                        >
                            <strong>onze voorwaarden</strong>
                        </router-link>&nbsp;en
                        <router-link :to="{ name: 'privacy' }" title="privacyverklaring" class="text-derect" target="_blank">
                            <strong>privacyverklaring</strong><span class="required">*</span>
                        </router-link>
                    </label>
                </div>

                <button
                    type="submit"
                    class="btn btn-warning btn-block"
                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                >
                    Volgende stap
                </button>
            </form>
            </div>
        </div>

        <footer class="pt-2 pb-4">
            <div class="container-fluid text-center" style="padding-left: 14px; padding-right: 14px;">
                <p class="mb-2">
                    <router-link
                        :to="{ name: 'login' }"
                        title="Heb je al een account? Login"
                        class="text-derect login-account"
                    >
                        Al een account?
                        <strong>Login</strong>
                    </router-link>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
    import RegisterApplicantEducation from "@/views/Register/Register-applicant-education.vue";
    import RegisterCompanyEducation from "@/views/Register/Register-company-education.vue";
    import RegisterApplicantHealthcare from "@/views/Register/Register-applicant-healthcare.vue";
    import RegisterCompanyHealthcare from "@/views/Register/Register-company-healthcare.vue";

    export default {
        props: ['type'],
        components: {
            RegisterApplicantEducation,
            RegisterCompanyEducation,
            RegisterApplicantHealthcare,
            RegisterCompanyHealthcare,
        },
        data() {
            return {
                form: {
                    branch: localStorage.getItem('branch'),
                    sub_branch: "",
                    firstname: "",
                    lastname: "",
                    name: "",
                    email: "",
                    invoice_email: "",
                    password: "",
                    password_confirmation: "",
                    type: this.type,
                    mobile: "",
                    search_lat: "",
                    search_lng: "",
                    street: "",
                    street_number: "",
                    house_addition: "",
                    postal_code: "",
                    city: ""
                },
                required: "",
                agree: false,
                pass1: true,
                pass2: true,
                access_token: null,
                response: null,
                linkedin_code: null,
                linkedin_state: null,
                social: false,
            };
        },
        computed: {
            educationComponent() {
                if (this.form.branch === "1" && this.type === 1) {
                    return "RegisterApplicantEducation";
                }
                if (this.form.branch === "1" && this.type === 2) {
                    return "RegisterCompanyEducation";
                }
                if (this.form.branch === "3" && this.type === 1) {
                    return "RegisterApplicantHealthcare";
                }
                if (this.form.branch === "3" && this.type === 2) {
                    return "RegisterCompanyHealthcare";
                }
                return null;
            }
        },
        async created() {},
        async mounted() {
            if (localStorage.getItem('branch') == null) {
                this.$router.replace({
                    name: "choose-branch"
                });
            }
            await this.fetchData();
        },
        watch: {
            $route: "fetchData",
            linkedin_code: {
                immediate: true,
                handler: function() {
                    this.checkCode();
                }
            }
        },
        methods: {
            async fetchData() {
                this.$store.state.notification.notifications = [];
                this.$data.form["type"] = this.type;
                if (this.type === 1) {
                    this.required = this.$store.state.applicant_fields;
                } else {
                    this.required = this.$store.state.company_fields;
                }

                if (localStorage.getItem("user-register")) {
                    const user_register = JSON.parse(localStorage.getItem("user-register"));
                    for (var obj in user_register) {
                        if (user_register[obj] && obj != "type") {
                            this.form[obj] = user_register[obj]; // update
                        }
                    }
                }

                // load the address from form
                if (localStorage.getItem("address")) {
                    const address = JSON.parse(localStorage.getItem("address"));
                        for (obj in address) {
                            if (address[obj]) {
                                this.form[obj] = address[obj];
                            }
                        }
                    }
                },
                async checkUserEmail() {
                    return new Promise(resolve => {
                        let formData = new FormData();
                        formData.append("email", this.form.email);
                        var url = this.$apiURI + "/auth/checkmail";
                        this.$http
                            .post(url, formData, {
                                headers: {
                                    Accept: "application/json"
                                }
                            })
                            .then(() => {
                                resolve();
                            })
                            .catch(error => {
                                // console.log(error.response.data.errors.email);
                                const notification = {
                                    type: "danger",
                                    message: error.response.data.errors.email[0]
                                    // message: "Er is een fout opgetreden.",
                                };
                                this.$store.dispatch("notification/replace", notification, {
                                    root: true
                                });
                                this.$store.state.loading = false;
                            });
                        });
                    },
                    async checkPasswords() {
                        return new Promise(resolve => {
                            if (this.form.password === this.form.password_confirmation) {
                                resolve();
                            } else {
                                const notification = {
                                    type: "danger",
                                    message: "Wachtwoorden komen niet overeen."
                                };
                                this.$store.dispatch("notification/replace", notification, {
                                    root: true
                                });
                                this.$store.state.loading = false;
                            }
                        });
                    },
                    async saveInfo() {
                        this.$store.state.notification.notifications = [];
                        localStorage.setItem("user-register", JSON.stringify(this.form));
                        if (this.form.type == 1) {
                            this.registerUser(this.form);
                            //   this.$router.replace({
                            //     name: "quick-step_2",
                            //     params: { action: "next" }
                            //   });
                            // });
                        } else if (this.form.type == 2) {
                            this.$router.replace({
                                name: "company-details",
                                params: { action: "next" }
                            });
                        }
                    },
                    async geocode() {
                        return new Promise(resolve => {
                            this.$gmapApiPromiseLazy().then(() => {
                                const geocoder = new google.maps.Geocoder();
                                var form = this.form;
                                const address = this.form.street_number + "+" + this.form.street + "+" + this.form.postal_code + "+" + this.form.city;

                                geocoder.geocode({ address }, function(results, status) {
                                    if (status === "OK") {
                                        const latitude = results[0].geometry.location.lat();
                                        const longitude = results[0].geometry.location.lng();
                                        form["search_lat"] = latitude;
                                        form["search_lng"] = longitude;
                                        resolve({status:'ok'});
                                    } else {
                                        resolve({status:'fail'});
                                    }
                                });
                            }).catch(() => {
                                resolve({status:'fail'});
                            });
                        });
                    },
                    async onSubmit() {
                        this.$store.state.loading = true;
                        let requiredfields = [];
                        if (this.form.branch === "1") {
                            requiredfields = ['sub_branch','email', 'password','password_confirmation'];
                        } else {
                            requiredfields = ['email', 'password','password_confirmation'];
                        }

                        if(this.type === 1)  {
                            requiredfields.push('firstname', 'lastname');
                        }

                        if(this.type === 2) {
                            requiredfields.push('name', 'invoice_email');
                        }

                        if(!this.areRequiredFieldsFilled(requiredfields)){
                            return false;
                        }

                        let geo = await this.geocode();

                        if (geo.status) {
                            await this.checkUserEmail();
                            await this.checkPasswords();
                            await this.saveInfo();
                        }
                    },
                    authenticate: function(provider) {
                        this.$auth
                            .authenticate(provider)
                            .then(success => {
                                console.log(success);
                            })
                            .catch(error => {
                                console.log(error);
                            });
                        this.checkCode();
                    },
                    checkCode() {
                        if (this.linkedin_code) {
                            console.log("run linkedin_code api");
                        }
                    },
                    AuthProvider(provider) {
                        var self = this;
                        this.$auth
                            .authenticate(provider)
                            .then(response => {
                                self.getGoogleAccess(response.code);
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    },
                    SocialLogin(provider, response) {
                        console.log(provider);
                        console.log(response);
                    },
                    areRequiredFieldsFilled(fields) {
                        for (let i in this.form) {
                            if(fields.includes(i) && !this.form[i]) {
                                const notification = {
                                    type: "danger",
                                    message: "Vul de verplichte velden in.",
                                    noTryAgain: true
                                };
                                this.$store.dispatch("notification/replace", notification, {
                                    root: true
                                });
                                this.$store.state.loading = false;
                                return false;
                            }
                        }

                        return true;
                    }
                },
                beforeRouteLeave(to, from, next) {
                    // remove the form-pending if accessing sub page
                    var subpages = [
                        "location",
                        "terms",
                        "privacy",
                        "applicant-terms",
                        "company-terms"
                    ];
                    if (subpages.indexOf(to.name) > -1) {
                        localStorage.setItem("user-register", JSON.stringify(this.form));
                        next();
                    } else {
                        next();
                    }
                }
            };
</script>

<style scoped></style>
